import SchemaViewer from './SchemaViewer';

export { SchemaViewer };
export default SchemaViewer;
